export default __webpack_public_path__ + "static/slide-05-dd1eeadc6e777e25057372bd7f4cb3cf.jpg";